var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8535 14.146C14.8999 14.1925 14.9368 14.2476 14.9619 14.3083C14.9871 14.369 15 14.4341 15 14.4997C15 14.5654 14.9871 14.6305 14.9619 14.6912C14.9368 14.7519 14.8999 14.807 14.8535 14.8535C14.807 14.8999 14.7519 14.9368 14.6912 14.9619C14.6305 14.9871 14.5654 15 14.4997 15C14.4341 15 14.369 14.9871 14.3083 14.9619C14.2476 14.9368 14.1925 14.8999 14.146 14.8535L10 10.7068L5.85398 14.8535C5.76017 14.9473 5.63292 15 5.50025 15C5.36758 15 5.24033 14.9473 5.14652 14.8535C5.0527 14.7597 5 14.6324 5 14.4997C5 14.3671 5.0527 14.2398 5.14652 14.146L9.29316 10L5.14652 5.85398C5.0527 5.76017 5 5.63292 5 5.50025C5 5.36758 5.0527 5.24033 5.14652 5.14652C5.24033 5.0527 5.36758 5 5.50025 5C5.63292 5 5.76017 5.0527 5.85398 5.14652L10 9.29316L14.146 5.14652C14.2398 5.0527 14.3671 5 14.4997 5C14.6324 5 14.7597 5.0527 14.8535 5.14652C14.9473 5.24033 15 5.36758 15 5.50025C15 5.63292 14.9473 5.76017 14.8535 5.85398L10.7068 10L14.8535 14.146Z",
    fill: "#FB4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close_red.a9c6c86844b18ac3f444f3b9ad2bf263.svg";
export { ForwardRef as ReactComponent };